import { render, staticRenderFns } from "./DetailsPageHeader.vue?vue&type=template&id=12ae18db&scoped=true&"
import script from "./DetailsPageHeader.vue?vue&type=script&lang=js&"
export * from "./DetailsPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPageHeader.vue?vue&type=style&index=0&id=12ae18db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae18db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VHover,VIcon,VImg})
